import { render, staticRenderFns } from "./data.vue?vue&type=template&id=5e6c61da&scoped=true"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"
import style0 from "./data.vue?vue&type=style&index=0&id=5e6c61da&prod&lang=less&scoped=true"
import style1 from "./data.vue?vue&type=style&index=1&id=5e6c61da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c61da",
  null
  
)

export default component.exports